import type { EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ExpandingChipList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingChipList";
import { environmentV2ChipList } from "~/components/Chips/index";
type EnvironmentsChipListProps = {
    environmentIds: string[];
    environments: EnvironmentV2Resource[];
};
export const EnvironmentsChipList = (props: EnvironmentsChipListProps) => <ExpandingChipList singularName={"environment"} ids={props.environmentIds} renderChipList={(ids) => environmentV2ChipList(props.environments, ids)}/>;
